import React, { Component } from 'react';
import { Icon, Progress } from 'semantic-ui-react'
import AWS from 'aws-sdk';
import JSZip from "jszip";

class StlUploadToS3 extends Component {
    constructor(props) {
        super(props);
        this.state = {
            success: false,
            progress: 0,
            active: true,
            error: false,
            uploadSTLToS3Flag: false
        };

        AWS.config.update({
            region: 'us-west-2',
            credentials: new AWS.CognitoIdentityCredentials({
                IdentityPoolId: 'us-west-2:9c66f931-8c9f-4425-b76f-59fc0d5fd2fb'
            })
        });

        this.bucketName = 'cctech-ml-work';
        this.s3 = new AWS.S3({
            apiVersion: '2006-03-01',
            params: { Bucket: this.bucketName }
        });

        this.setProgressInterval = null
    }

    onUploadComplete(data) {
        // console.log("upload status : ", data);
        this.setState({
            s3ObjUID: data.body.data.UID,
            progress: 100,
            success: true,
            active: false,
            error: false,
        })

        this.props.onStlUploadDone(this.state)
    }

    uploadSTLToS3() {
        // console.log("uploading to s3 : ", this.props.parentState.uploadData);
        if (this.props.parentState.isCreateNew) {
            let uid = this.props.geomId;
            // console.log('uid : ', uid)

            var fileKey = 'ml-mesh-segmentation/stl-upload/' + uid + '/geometry.zip';
            // console.log("fileKey : ", fileKey)

            var reader = new FileReader();
            reader.readAsArrayBuffer(this.props.parentState.uploadData.file);
            reader.onload = evt => {
                var zip = new JSZip();
                zip.file("geometry.stl", evt.target.result);
                zip.generateAsync({
                    type: "blob",
                    compression: "DEFLATE",
                    compressionOptions: {
                        level: 9
                    }
                }).then(async content => {
                    this.s3.upload({
                        Key: fileKey,
                        Body: content,
                        ACL: 'public-read'
                    }).on('httpUploadProgress', (evt) => {
                        // console.log('Progress:', (evt.loaded / evt.total) * 100);
                        this.setState({
                            progress: Math.ceil((evt.loaded / evt.total) * 100)
                        })
                    }).send((err, data) => {
                        if (err) {
                            console.log('There was an error uploading your file: ', err.message);
                            this.setState({
                                active: false,
                                error: true,
                            })
                        }

                        this.setState({
                            s3ObjUID: uid,
                            progress: 100,
                            success: true,
                            active: false,
                            error: false,
                        })
                        // console.log('Successfully uploaded file.', data);
                        this.props.onStlUploadDone(this.state)
                    });
                });
            };
            reader.onerror = function (evt) {
                console.log("error reading file");
            };


        }
        else {
            this.setProgressInterval = setInterval(this.setProgressOnInterval.bind(this), 200);
        }
    }

    setProgressOnInterval() {
        if (this.state.progress < 75) {
            this.setState({
                progress: this.state.progress + 25
            })
        }
        else {
            this.setState({
                progress: 100,
                success: true,
                active: false,
                error: false,
            })
            this.props.onStlUploadDone(this.state)
        }
    }

    releaseProgressInterval() {
        clearInterval(this.setProgressInterval);
    }

    componentDidMount() {
        this.uploadSTLToS3()
    }

    render() {

        if (this.state.progress === 100) {
            this.releaseProgressInterval()
        }

        let uploadStatusComp
        if (!this.state.error) {
            uploadStatusComp = <Progress percent={this.state.progress} color='blue' active={this.state.active} progress>{this.state.success ?
                "Geometry uploaded" : "Uploading geometry..."}</Progress>
        }
        else {
            uploadStatusComp = <Progress percent={100} error>Something went wrong(</Progress>
        }

        return (
            <>
                <div style={{ paddingTop: '1rem', paddingBottom: '1rem' }}>
                    <div className={"ui small header font-weight-bold"}>
                        File Upload
                    </div>
                    {uploadStatusComp}
                </div>
                <div className={"ui grey dashed divider no-margin"}></div>
            </>
        );
    }
}

export default StlUploadToS3;